const STYLES = {
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  sap_draft_pending_review: "bg-amber-50 text-amber-700 border-amber-200",
  sap_draft_grn_linked_review: "bg-teal-50 text-teal-700 border-teal-200",
  sap_draft_reconciliation_required: "bg-red-50 text-red-700 border-red-200",
  sap_posting_submitting: "bg-amber-50 text-amber-700 border-amber-200",
  sap_posting_reconciliation_required: "bg-red-50 text-red-700 border-red-200",
  invoice_posted: "bg-blue-50 text-blue-700 border-blue-200",
  released: "bg-emerald-50 text-emerald-700 border-emerald-200",
  error: "bg-red-50 text-red-700 border-red-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  pending_reconciliation: "bg-amber-50 text-amber-700 border-amber-200",
  reconciled: "bg-green-50 text-green-700 border-green-200",
  blocked: "bg-red-100 text-red-800 border-red-300",
  posted: "bg-blue-50 text-blue-700 border-blue-200",
};

export function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex whitespace-nowrap font-mono text-[10px] font-semibold px-2 py-0.5 rounded-full border uppercase tracking-wide ${
        STYLES[status] || STYLES.draft
      }`}
    >
      {status?.replace(/_/g, " ") || "—"}
    </span>
  );
}
